<template>
    <div class="histogram">
        <div class="inner" :style="{ height: height + 'px' }">
            <div
                class="d-flex justify-content-between h-100 align-items-end x-axis"
            >
                <div
                    v-for="(n, i) in data"
                    :key="'value-' + i"
                    class="histogram-column"
                    :style="{ height: columnHeight(n.value) }"
                    v-b-tooltip.hover
                    :title="n.value"
                >
                    <div class="histogram-label numeric">
                        <span>{{ n.label }}</span>
                    </div>
                </div>
            </div>

            <div class="y-axis align-top numeric">
                <table class="h-100 histogram-label">
                    <tr>
                        <td class="align-top" v-if="max">{{ max }}</td>
                    </tr>
                    <tr>
                        <td class="align-middle" v-if="max">{{ max / 2 }}</td>
                    </tr>
                    <tr>
                        <td class="align-bottom">0</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: { type: Array, required: true, default: () => [] },
        height: { type: Number, required: false, default: 150 },
    },
    computed: {
        max: function () {
            return this.data ? Math.max(...this.data.map((n) => n.value)) : 0;
        },
    },
    methods: {
        columnHeight: function (value) {
            if (!value) {
                return "1px";
            }

            return (value ? (value / this.max) * 100 : 0) + "%";
        },
    },
};
</script>

<style lang="scss">
@use "@/scss/custom";
.inner {
    position: relative;
    margin-bottom: 30px;
}

.histogram-column {
    background-color: custom.$color_blue;
    width: 28px;
    border-radius: 8px;
    position: relative;
    display: inline-block;
    margin-right: 18px;

    &:last-of-type {
        margin-right: 0;
    }
}

.histogram-label {
    font-size: 12px;
    color: custom.$dark;
}

.x-axis {
    margin-left: 40px;

    .histogram-label {
        position: absolute;
        bottom: -30px;
        height: 11px;
        width: 28px;

        text-align: center;

        span:before {
            content: "";
            margin-left: -100%;
        }
        span:after {
            content: "";
            margin-right: -100%;
        }
    }
}

.y-axis {
    position: absolute;
    display: inline-block;
    height: 100%;
    text-align: right;
    top: 0;
}
</style>
